import axios from "axios";

export const subscribe = async (email: string, firstName: string, lastName: string) => {
  const headers = {
    "Access-Control-Expose-Headers": "Access-Control-Allow-Origin",
    "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
    // 'Access-Control-Allow-Credentials': true,
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  };
  const data = {
    TableName: "subscriptions",
    Item: { email: email, firstName: firstName, lastName: lastName },
  };
  await axios
    .post("https://d222hu8pcowl39.cloudfront.net/default/querying", data, {
      headers,
    })
    .catch((e) => console.log(e));
};